import { dehydrate, hydrate, type QueryClient } from "@tanstack/react-query"

// Persist the query cache to localStorage for offline reads; mutations are never persisted.

const STORAGE_KEY = "slumra-query-cache"
const DEBOUNCE_MS = 1000

export function hydrateQueryCache(queryClient: QueryClient) {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (raw) hydrate(queryClient, JSON.parse(raw))
  } catch {
    // ignore
  }
}

export function startQueryPersistence(queryClient: QueryClient) {
  let timer: ReturnType<typeof setTimeout> | undefined
  return queryClient.getQueryCache().subscribe(() => {
    clearTimeout(timer)
    timer = setTimeout(() => {
      try {
        const state = dehydrate(queryClient, {
          // meta.persist === false opts a query out (e.g. the auth session, which
          // must be revalidated over the network on every app boot, not restored).
          shouldDehydrateQuery: (query) =>
            query.state.status === "success" && query.meta?.persist !== false,
        })
        localStorage.setItem(STORAGE_KEY, JSON.stringify(state))
      } catch {
        // ignore
      }
    }, DEBOUNCE_MS)
  })
}
